// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  sentry: {
    dsn: '', // Set NX_SENTRY_DSN env var for development, or leave empty to disable
    environment: 'development',
  },
};
